import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material"
import MaterialReactTable from "material-react-table"
import React, { useMemo, useState } from "react"
//Import Material React Table Translations
import { MRT_Localization_ES } from "material-react-table/locales/es"
//Icons Imports
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd"
import VisibilityIcon from "@mui/icons-material/Visibility"
import { ThemeProvider, darken } from "@mui/material"

const TablaPGDEquipo = ({
  columnas,
  lineas,
  titulo,
  handleOpen,
  funcionEliminar,
  acciones = false,
  accionAgregar = false,
  primeraAccion = false,
  segundaAccion = false,
}) => {
  const [data, setData] = useState(lineas)
  const columns = useMemo(() => columnas, [data])
  const [open, setOpen] = useState(false)
  const [rowToDelete, setRowToDelete] = useState(null)
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  React.useEffect(() => {
    if (lineas.length > 0) {
      setData(lineas)
    } else {
      setData([])
    }
  }, [lineas, columnas])

  const openModal = (row) => {
    let id = row.getValue("id")
    let modal = "autoevaluacion"
    handleOpen(id, modal, lineas)
  }
  const openModal2 = (row, statuscode) => {
    let id = row.getValue("id")
    let readOnly = statuscode == 100000003 ? true : false
    let modal = "encuentro feedback"
    handleOpen(id, modal, readOnly)
  }
  const openModalNew = () => {
    try {
      handleOpen()
    } catch (error) {
      console.log(error)
    }
  }

  // ETAPAS:
  // 1. Definición de Objetivos: 100000000
  // 2. Gestión y Seguimiento: 100000001
  // 3. Balance y Cierre de Año: 100000002

  return (
    <>
      <ThemeProvider>
        <MaterialReactTable
          muiTablePaginationProps={{
            rowsPerPageOptions: [5, 10],
            showFirstLastPageButtons: false,
          }}
          onPaginationChange={setPagination}
          state={{ pagination }}
          columns={columns}
          data={data}
          muiTablePaperProps={{
            sx: (theme) => ({
              borderRadius: '0.55rem',
              border: darken(theme.palette.background.default, 0.1),
              bgcolor: darken(theme.palette.primary.dark, 0.1),
              maxWidth: '100vw',
              m: 'auto',
            }),
          }}
          enableFullScreenToggle={false}
          enableColumnFilterModes={true}
          enableColumnOrdering={true}
          enableColumnActions={true}
          enableColumnFilters={true}
          enableSorting={true}
          enableColumnResizing
          columnResizeMode="onChange"
          enablePinning
          enableRowActions={true}
          enableStickyHeader
          initialState={{ showColumnFilters: false, columnVisibility: { id: false }, density: "compact" }}
          positionToolbarAlertBanner="bottom"
          localization={MRT_Localization_ES}
          defaultColumn={{
            maxSize: 400,
            minSize: 40,
          }}
          muiTableContainerProps={{ sx: { maxWidth: "95vw", fontSize: { xs: ".7rem", md: "7rem" } } }}
          enableEditing={false}
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: "flex", gap: "1rem" }}>
              {row.original.statuscode === 100000000 || row.original.statuscode === 100000001 ? (
                <Tooltip arrow placement="left" title={<Typography sx={{ fontSize: "0.8rem" }}>{row.original.statuscode === 100000000 && 'Definición de objetivos' || row.original.statuscode === 100000001 && 'Gestión y Seguimiento' || row.original.statuscode === 100000001 && 'Balance y Cierre de Año'}</Typography>}>
                  <IconButton>
                    <VisibilityIcon onClick={() => openModal(row)} />
                  </IconButton>
                </Tooltip>
              ) : null}
              {row.original.statuscode === 100000002 || row.original.statuscode === 100000003 ? (
                <Tooltip
                  arrow
                  placement="left"
                  title={
                    <Typography sx={{ fontSize: "0.8rem" }}>
                      {row.original.statuscode === 100000002 ? "Balance y Cierre de Año" : "Ver"}
                    </Typography>
                  }
                >
                  <IconButton>
                    <VisibilityIcon onClick={() => openModal2(row, row.original.statuscode)} />
                  </IconButton>
                </Tooltip>
              ) : null}
            </Box>
          )}
          renderTopToolbarCustomActions={() => (
            <>
              {accionAgregar ? (
                <Button color="secondary" onClick={() => openModalNew()} variant="contained">
                  <PlaylistAddIcon />
                </Button>
              ) : null}
              <Typography variant="subtitle" p="2px">
                {titulo}
              </Typography>
            </>
          )}
        />
      </ThemeProvider>
    </>
  )
}

export default React.memo(TablaPGDEquipo)
